module.exports = __webpack_public_path__ + "static/media/assignment.ab628823.svg";